import { typedRpcValue, typedSelect } from '@/lib/supabaseTypedQuery';

type WorkspaceContextSnapshot = {
  workspace?: { id: string } | null;
} | null;

type WorkspaceMembership = {
  workspace_id: string;
  role: string | null;
};

/**
 * A person's main workspace under the one database rule (default_workspace_for_user):
 * shared with another member first, then owned, then earliest joined. A failed
 * lookup throws, so the caller's retry handles it. It never guesses.
 */
export async function fetchMainWorkspaceId(userId: string): Promise<string | null> {
  const { data, error } = await typedRpcValue<string>('default_workspace_for_user', { p_user_id: userId });
  if (error) throw error;
  return data ?? null;
}

export async function resolveWorkspaceId(
  userId: string,
  workspaceCtx?: WorkspaceContextSnapshot,
): Promise<string | null> {
  const contextWorkspaceId = workspaceCtx?.workspace?.id;
  if (contextWorkspaceId) {
    return contextWorkspaceId;
  }

  const { data, error } = await typedSelect<WorkspaceMembership>(
    'workspace_members',
    'workspace_id, role'
  )
    .eq('user_id', userId);

  if (error) {
    throw error;
  }

  if (!data || data.length === 0) {
    return null;
  }

  if (data.length === 1) {
    return data[0]?.workspace_id ?? null;
  }

  return fetchMainWorkspaceId(userId);
}
